import { forConversation } from '../channels';
import { objectSchemaOf, Joi, actionCreator } from '../helpers';
import type { ISubmitKeyboardParams } from './submitKeyboard';
import { submitKeyboardParamsSchema } from './submitKeyboard';

// this action is used to publish an update to HIL
export const KEYBOARD_RESPONSE = 'USER_INPUT/KEYBOARD_RESPONSE';

type KeyboardResponseParams = ISubmitKeyboardParams;
const keyboardResponseParamsSchema = submitKeyboardParamsSchema;

export interface IKeyboardResponseAction {
  type: typeof KEYBOARD_RESPONSE;
  payload: KeyboardResponseParams;
}

export const keyboardResponseActionSchema = objectSchemaOf<IKeyboardResponseAction>(
  {
    type: Joi.string().required().valid(KEYBOARD_RESPONSE),
    payload: keyboardResponseParamsSchema.required(),
  }
);

export const keyboardResponse = actionCreator({
  type: KEYBOARD_RESPONSE,
  schema: keyboardResponseActionSchema,
  channels: [forConversation],
});
